import { Factory } from 'rosie';
import { IdGenerator } from '../lib/uuid';

import '../conversation_item_factory';

Factory.define('ConversationMessage').attr('type', 'CONVERSATION_MESSAGE');

Factory.define('ConversationMessageWithDefaults')
  .extend('ConversationMessage')
  .attr('externalId', 'example-externalId')
  .attr('companyAddress', '+15552224444')
  .attr('customerAddress', '+15557775555')
  .attr('direction', 'INCOMING')
  .attr('channel', 'WHATSAPP')
  .attr('content', ['content'], content => Factory.attributes('MessageContentTypeTextWithDefaults', content))
  .attr('meta', {})
  .attr('reactions', [])
  .attr('status', {
    value: 'DELIVERED',
    errorCode: '',
  })
  .attr('statusUpdates', []);

Factory.define('ConversationMessageItem')
  .extend('ConversationItem')
  .attr('content', ['content'], content => Factory.attributes('ConversationMessage', content));

Factory.define('ConversationMessageItemWithDefaults')
  .extend('ConversationItemWithDefaults')
  .attr('content', ['content'], content => Factory.attributes('ConversationMessageWithDefaults', content));

Factory.define('ConversationMessageInstagramComment')
  .extend('ConversationMessage')
  .attr('externalId', () => IdGenerator.newId())
  .attr('companyAddress', '@company_instagram')
  .attr('customerAddress', '@customer_instagram')
  .attr('direction', 'INCOMING')
  .attr('channel', 'INSTAGRAM_COMMENT')
  .attr('content', ['content'], content => Factory.attributes('MessageContentTypeTextWithDefaults', content))
  .attr('meta', {
    mediaUrl: 'https://scontent-sjc3-1.cdninstagram.com/v/t51.2885-15/example-media.jpg',
    mediaType: 'IMAGE',
    mediaText: 'Check out our latest product announcement!',
    mediaPermalink: 'https://www.instagram.com/p/ABC123DEF456/',
    moderationStatus: null,
  })
  .attr('status', {
    value: 'RECEIVED',
    errorCode: '',
  });

Factory.define('ConversationMessageInstagramCommentWithDefaults').extend('ConversationMessageInstagramComment');

Factory.define('ConversationMessageInstagramCommentItem')
  .extend('ConversationItem')
  .attr('content', ['content'], content => Factory.attributes('ConversationMessageInstagramComment', content));

Factory.define('ConversationMessageInstagramCommentItemWithDefaults')
  .extend('ConversationItemWithDefaults')
  .attr('content', ['content'], content =>
    Factory.attributes('ConversationMessageInstagramCommentWithDefaults', content)
  );
